import React from "react";
import { AlertIndicator, alertTypes } from "@SeemplicityDev/shared";
import { pluralize } from "../../utils";

export interface HiddenWidgetsBannerProps {
  widgetsCount: number;
  dashboardsCount: number;
  entityLabel: "filter" | "scope";
}

const HiddenWidgetsBanner: React.FC<HiddenWidgetsBannerProps> = ({
  widgetsCount,
  dashboardsCount,
  entityLabel,
}) => (
  <div
    className={"dependencies-hidden-widgets-banner"}
    data-testid={"dependencies-hidden-widgets-banner"}
  >
    <AlertIndicator
      type={alertTypes.WARNING}
      hasMaxWidth={false}
      content={
        <span>
          {`This ${entityLabel} is also used in `}
          <span className={"dependencies-hidden-widgets-count"}>
            {`${pluralize(widgetsCount, "widget")} on ${pluralize(dashboardsCount, "private dashboard")}`}
          </span>
          {`, which ${widgetsCount === 1 ? "isn't" : "aren't"} listed below.`}
        </span>
      }
    />
  </div>
);

export default HiddenWidgetsBanner;
